// src/i18n/locales/en/common.ts
export const enCommonTranslations = {
	common: {
		languageName: 'English',
		languageCode: 'en',
		notAvailable: 'Not available',
		collapse: 'Collapse',
		expand: 'Expand',
		cancel: 'Cancel',
		done: 'Done',
	},
	header: {
		home: 'Home',
		features: 'Features',
		pricing: 'Pricing',
		testimonials: 'Testimonials',
		login: 'Login'
	},
	footer: {
		description: 'Modern digital menu solutions for restaurants that want to elevate their customer experience and streamline operations.',
		product: 'Product',
		features: 'Features',
		pricing: 'Pricing',
		demo: 'Demo',
		company: 'Company',
		about: 'About Us',
		blog: 'Blog',
		careers: 'Careers',
		resources: 'Resources',
		documentation: 'Documentation',
		support: 'Support',
		contact: 'Contact',
		legal: 'Legal',
		terms: 'Terms of Service',
		privacy: 'Privacy Policy',
		cookies: 'Cookie Policy',
		allRightsReserved: 'All rights reserved',
		poweredBy: 'Powered by'
	},
	notFound: {
		title: 'Page Not Found',
		message: 'The page you are looking for doesn\'t exist or has been moved.',
		homeButton: 'Back to Home'
	},
	weekDays: {
		monday: 'Monday',
		tuesday: 'Tuesday',
		wednesday: 'Wednesday',
		thursday: 'Thursday',
		friday: 'Friday',
		saturday: 'Saturday',
		sunday: 'Sunday',
		short: {
			mon: 'Mon',
			tue: 'Tue',
			wed: 'Wed',
			thu: 'Thu',
			fri: 'Fri',
			sat: 'Sat',
			sun: 'Sun'
		}
	},
	spiceLevels: {
		none: 'None',
		mild: 'Mild',
		medium: 'Medium',
		hot: 'Hot',
		extra_hot: 'Extra Hot'
	},
	restaurant: {
		tabs: {
			info: 'Info',
			menu: 'Menu',
			reviews: 'Reviews',
			location: 'Location',
			feedback: 'Feedback',
		},
		location: {
			title: 'Find Us',
			getDirections: 'Get Directions',
			viewOnGoogleMaps: 'View on Google Maps',
			mapPlaceholder: 'Map would appear here in production',
			transportOptions: 'Transport Options',
			bycar: 'By Car',
			carDescription: 'Free parking available for customers. Enter from Main Street.',
			publicTransport: 'Public Transport',
			publicTransportDescription: 'Bus routes 10, 15, and 22 stop right outside. Subway station is a 5-minute walk.',
			walking: 'Walking',
			walkingDescription: 'We\'re a 10-minute walk from downtown. Follow the river path for a scenic route.'
		},
		info: {
			about: 'About',
			reviews: 'reviews',
			cuisine: 'Cuisine',
			contactInfo: 'Contact Information',
			address: 'Address',
			phone: 'Phone',
			hours: 'Hours',
			website: 'Website',
			closed: 'Closed',
			open: 'Open',
			amenities: 'Amenities',
			viewOnGoogleMaps: 'View on Google Maps',
			specialFeatures: 'Special Features',
			specialFeaturesDescription: 'We offer a range of amenities to enhance your dining experience.',
			freeWifi: 'Free Wi-Fi',
			freeWifiDescription: 'High-speed internet access available throughout the restaurant.',
			parking: 'Parking',
			parkingDescription: 'Free parking available for customers in our private lot.',
			outdoorSeating: 'Outdoor Seating',
			outdoorSeatingDescription: 'Beautiful patio seating area, perfect for nice weather.',
			payment: 'Payment Options',
			paymentDescription: 'We accept all major credit cards, Apple Pay, and Google Pay.',
			description: 'Description'
		},
		menu: {
			popularCategories: 'Popular Categories',
			viewFullMenu: 'View Full Menu',
			fullMenu: 'Full Menu',
			exploreAllDishes: 'Explore our complete selection of dishes',
			popularDescription: 'Most loved dishes by our customers',
			moreItems: 'more items',
			noCategories: 'No Menu Categories',
			noCategoriesDescription: 'This restaurant has not added any menu categories yet.',
			alreadyInCart: 'Item already in cart',
			addToCart: 'Add',
			orderError: 'Failed to place order. Please try again.',
		},
		reviews: {
			title: 'Customer Reviews',
			overview: 'Rating Overview',
			filter: 'Filter Reviews',
			count: 'reviews',
			sortBy: 'Sort by',
			newest: 'Newest First',
			highest: 'Highest Rating',
			lowest: 'Lowest Rating',
			loadMore: 'Load More Reviews',
			writeReview: 'Write a Review',
			helpful: 'Helpful',
			replies: 'Replies',
			filterBy: 'Filter by rating',
			allRatings: 'All ratings',
			noReviews: 'No reviews found',
			noReviewsMessage: 'No reviews match your current filter. Try adjusting your filter criteria.',
			clearFilters: 'Clear filters',
		},
		rating: {
			title: 'Customer Reviews',
			basedOn: 'Based on {{count}} reviews',
			poweredBy: 'Powered by Google Reviews',
			addRate: 'Add Rate',
			showLess: 'Show Less',
			showMore: 'Show All {{count}} Reviews',
		},

		loading: 'Loading restaurant information...',
		notFound: {
			title: 'Restaurant Not Found',
			message: 'Sorry, we couldn\'t find the restaurant you\'re looking for.',
			homeButton: 'Back to Home'
		},
	},
	menuItem: {
		noIngredients: 'No ingredient information available',
		noNutritionals: 'No nutritional information available',
		noVariants: 'No variants available',
		noCustomization: 'This item has no customization options',
		noDetails: 'No additional details available',
		calorie: 'Calorie',
		calories: 'Calories',
		theCalories: 'Calories',
		calorieUnit: 'cal',
		unavailable: 'Unavailable',
		addToOrder: 'Add to Order',
		cartDisabled: 'Cart Disabled',
		alreadyInCart: 'Item already in cart',
		price: 'Price',
		addons: 'Add-ons',
		each : 'each',
		show: 'Show',
		hide: 'Hide',
		unavailble : 'This item is currently unavailable',
		details: 'Details',
		ingredients: 'Ingredients',
		nutrition: 'Nutrition',
		dietary: 'Dietary',
		customize: 'Customize',

	},
	share: {
		title: 'Share Restaurant',
		copyLink: 'Copy Link',
		whatsapp: 'WhatsApp',
		facebook: 'Facebook',
		twitter: 'Twitter',
		telegram: 'Telegram',
		email: 'Email',
		linkCopied: 'Link copied to clipboard!'
	},
	menu: {
		addLocation: "Add My Location",
		locationAdded: "Location Added",
		loading: 'Loading menu...',
		searchPlaceholder: 'Search menu items...',
		noResults: 'No Results Found',
		noSearchResults: 'No Search Results',
		noSearchResultsDescription: 'No items match your search criteria. Try adjusting your search terms.',
		tryDifferentSearch: 'Try a different search term or clear the filters',
		filters: 'Filters',
		clearFilters: 'Clear Filters',
		dietaryPreferences: 'Dietary Preferences',
		vegetarian: 'Vegetarian',
		vegan: 'Vegan',
		glutenFree: 'Gluten Free',
		featuredItems: 'Featured Items',
		featuredDescription: 'Our most popular dishes and chef\'s recommendations',
		quickOrder: 'Quick Order',
		addToOrder: 'Add to Order',
		customizeYourOrder: 'Customize your order below',
		categories: 'Categories',
		allCategories: 'All Categories',
		ingredients: 'Ingredients',
		nutritionalInfo: 'Nutritional Info',
		dietaryInfo: 'About Dietary Labels',
		dietaryInfoDesc: 'These labels indicate the dietary characteristics of this item. Always check with staff if you have specific allergies or dietary restrictions.',
		noDietaryPreferences: 'No Dietary Information',
		noDietaryPreferencesDesc: 'This item doesn\'t have any dietary preference information available.',
		noItems: 'No items in this category',
		item: 'Item',
		items: 'Items',
		spiceLevel: 'Spice Level',
		calorie: 'calories',
		preparationTime: 'Preparation Time',
		minute: 'min',
		minutes: 'min',
		viewDetails: 'View Details',
		itemDetails: 'Details',
		variant : 'Variants',
		unavailable: 'Unavailable',
		popular: 'Popular',
		itemCards: 'Item Cards',
		customizations: 'customizations',
		clickToCustomize: 'Click to customize',
		customizeItem: 'Customize Item',
		quantity: 'Quantity',
		willCreateCards: 'Will add {{count}} items to this card',
		none: 'None',
		customizeAndAdd: 'Customize & Add to Order',
		addWithoutCustomization: 'Add Without Customization',
		saveToOrder: 'Save to Order',
		update: 'Update',
		totalPrice: 'Total Price',
		customizationOptions: 'Customization Options',
		selectUpTo: 'Select up to',
		moreOptions: 'more options',
		customizePrompt: 'Use "Customize & Add" button below to personalize this item',
		maxReached: 'Max reached',
		availableVariants: 'Available Variants',
		customize: 'Customize',
		webMaps : "Web maps",
		viewMode: {
			grid: 'Grid View',
			list: 'List View'
		},
		SubcategoryStyle: {
			tabs: 'Tab View',
			dropdown: 'Dropdown View'
		},

		showMore: 'Show More',
		showLess: 'Show Less',
		expandAll: 'Expand All',
		collapseAll: 'Collapse All',
		zoomImage: 'Zoom Image',
		view : 'View',
		youMightAlsoLike: 'You might also like',
		
		// Cart translations
		cart: {
			save : 'Save',
			title: 'My Cart',
			empty: 'Your cart is empty',
			item: 'item',
			items: 'items',
			total: 'Total',
			checkout: 'Checkout',
			orderViaWhatsApp: 'Order via WhatsApp',
			note: 'Note',
			addNote: 'Add note',
			editNote: 'Edit note',
			noteExample: 'e.g., No onions, extra spicy...',
			mobile: 'Mobile Number',
			mobilePlaceholder: '+1 50 123 456 78',
			deliveryLocation: 'Delivery Location',
			addressPlaceholder: 'Enter your delivery address...',
			or: 'OR',
			and : 'AND',
			clearAll: 'Clear All',
			yourCart: 'Your Cart',
			orderType: 'Order Type',
			delivery: 'Delivery',
			deliveryZone: 'Delivery Zone',
			selectZone: 'Select delivery zone',
			deliveryFee: 'Delivery Fee',
			subtotal: 'Subtotal',
			pickup: 'Pickup',
			pickupInstructions: 'Pickup Instructions',
			pickupDetails: 'Your order will be ready for pickup at our restaurant',
			expectedArrivalTime: 'Expected Arrival Time',
			arrivalTimeHint: 'When do you expect to arrive for pickup?',
			minutes: 'minutes',
			hour: 'hour',
			firstName: 'First Name',
			lastName: 'Last Name',
			firstNamePlaceholder: 'Enter your first name',
			lastNamePlaceholder: 'Enter your last name',
			mobileRequired: 'Mobile number is required',
			notePlaceholder: 'Add special instructions for your order',
			location: {
				get: 'Get Current Location',
				getting: 'Getting location...',
				detected: 'Location detected successfully',
				current: 'Current Location',
				manual: 'Manual Address',
				deliveryRoute: 'Delivery Route',
				openInMaps: 'Open in Maps',
				routeToYourLocation: 'Route to your location',
				error: 'Unable to get location. Please enter manually.',
				yourLocation: 'Your Location',
				locationNotAvailable: 'Location information not available',
				mapRequiresApiKey: 'Map requires Google Maps API key. Please check the setup documentation.',
				gettingRoute: 'Getting route...',
				navigateHere: 'Navigate Here',
				getMyLocation: 'Get My Location',
				navigateFromMyLocation: 'Navigate from My Location',
				showRoute: 'Show Route',
				hideRoute: 'Hide Route',
				startNavigation: 'Start Navigation',
				navigationActive: 'Navigation Active',
				routeTo: 'Route to {{restaurantName}}',
				distance: 'Distance',
				time: 'Time',
				locationDetails: 'Location Details',
				pickupLocation: 'Pickup Location',
				locationMap: 'Location Map',
				restaurant: 'Restaurant',
				navigateToRestaurant: 'Navigate to restaurant',
				refresh: 'Refresh Location'
			},
					confirmClearCart: 'Are you sure you want to clear the cart?',
					confirmClearMessage: 'This will remove all items from the cart. This action cannot be undone.',
					confirmClearCartTitle: 'Are you sure you want to clear the cart?',
					confirmClearCartMessage: 'This will remove all items from the cart. This action cannot be undone.',
					cancel: 'Cancel',
					yes: 'Yes',
			newOrder: 'New Order',
			thankYou: 'Thank you for your order!'
		},
		
		myCart: 'My Cart',
		shoppingCart: 'Shopping Cart',
		emptyCart: 'Cart is Empty',
		emptyCartMessage: 'Add some delicious items to get started',
		startShopping: 'Start Shopping',
		startOrdering: 'Start Ordering',
		yourOrder: 'Your Order',
		specialInstructions: 'Special instructions for this item',
		addNote: 'Add Note',
		editNote: 'Edit Note',
		removeItem: 'Remove Item',
		note: 'Note',
		addNotePrompt: 'Add special instructions for this item',
		noteExample: 'e.g., No onions, extra spicy...',
		done: 'Done',
		checkout: 'Checkout',
		orderViaWhatsApp: 'Order via WhatsApp',
		deliverInformation: 'Delivery Information',
		orderSummary: 'Order Summary',
		customerInfo: 'Customer Information',
		mobileNumber: 'Mobile Number',
		enterMobile: 'Enter your mobile number',
		mobileRequired: 'Mobile number is required',
		mobileInvalid: 'Please enter a valid mobile number',
		deliveryAddress: 'Delivery Address',
		enterAddress: 'Enter your full delivery address',
		addressRequired: 'Address is required',
		or: 'OR',
		useCurrentLocation: 'Use Current Location',
		locationCaptured: 'Location captured successfully',
		geolocationNotSupported: 'Geolocation is not supported by your browser',
		locationError: 'Unable to retrieve your location. Please try again',
		personalInfo: 'Personal Information',
		name: 'Name',
		enterName: 'Enter your name',
		tableNumber: 'Table Number',
		enterTableNumber: 'Enter table number',
		orderNote: 'Order Note',
		enterOrderNote: 'Any special instructions for your order',
		tip: 'Tip',
		subtotal: 'Subtotal',
		tax: 'Tax',
		total: 'Total',
		proceedToCheckout: 'Proceed to Checkout',
		placeOrder: 'Place Order',
		orderPlaced: 'Order Placed Successfully',
		orderConfirmation: 'Your order has been placed. The restaurant will start preparing your order soon.',
		continueBrowsing: 'Continue Browsing',
		orderDetails: 'Order Details',
		addMoreItems: 'Add More Items',
		orderAgain: 'Order Again',

		sortOptions: {
			default: 'Default',
			priceAsc: 'Price: Low to High',
			priceDesc: 'Price: High to Low',
			nameAsc: 'Name: A to Z',
			nameDesc: 'Name: Z to A'
		}
	},
	home: {
		hero: {
			title: 'Transform Your Restaurant Menu Experience',
			subtitle: 'Elevate your dining service with interactive digital menus that delight customers and boost your business',
			primaryCta: 'Get Started',
			secondaryCta: 'See Demo',
			imageAlt: 'Interactive restaurant menu preview'
		},
		features: {
			title: 'Everything You Need for Modern Dining',
			subtitle: 'Our platform offers comprehensive solutions to digitize and enhance your restaurant experience',
			digitalMenu: {
				title: 'Interactive Digital Menus',
				description: 'Create beautiful, customizable digital menus that showcase your offerings with high-quality images and detailed descriptions'
			},
			mobileOrdering: {
				title: 'Mobile Ordering',
				description: 'Allow customers to browse your menu and place orders directly from their smartphones for dine-in, takeout, or delivery'
			},
			analytics: {
				title: 'Customer Insights',
				description: 'Gain valuable data on customer preferences, popular items, and ordering patterns to optimize your business'
			}
		},
		testimonials: {
			title: 'Success Stories',
			subtitle: 'Hear from restaurant owners who have transformed their business with our platform',
			items: [
				{
					name: 'Alex Johnson',
					role: 'Owner',
					restaurantName: 'Bistro Elegance',
					content: 'Since implementing this digital menu system, we\'ve seen a 30% increase in average order value. Customers love the visual experience and our staff spends less time explaining menu items.'
				},
				{
					name: 'Maria Rodriguez',
					role: 'Head Chef',
					restaurantName: 'Spice Fusion',
					content: 'The ability to showcase our specialty dishes with high-quality images has significantly increased their orders. The platform is intuitive for both our staff and customers.'
				},
				{
					name: 'David Chen',
					role: 'Manager',
					restaurantName: 'Urban Plate',
					content: 'The analytics provided by this platform have been game-changing for our business. We can now make data-driven decisions about our menu offerings and pricing strategy.'
				}
			]
		},
		cta: {
			title: 'Ready to Modernize Your Restaurant?',
			description: 'Join thousands of restaurants already using our platform to enhance customer experience and boost revenue',
			buttonText: 'Start Your Free Trial'
		}
	},
	categories: {
		more: 'more',
		subcategories: 'Subcategories',
		noCategories: 'No Categories Available',
		noCategoriesDescription: 'This restaurant has not added any menu categories yet.',
		ourCategories: 'Our Categories',
		categoriesDescription: 'Description of our categories'
	},
	// Additional translations for LocationMap
	openInMaps: 'Open in Maps App',
	webMaps: 'Web Maps',
	deliveryAddress: 'Delivery Address',
	clearAll : 'Clear All',
	activeFilters : 'Active Filters',
	feedback: {
		title: 'How was your experience?',
		subtitle: 'Your feedback helps us serve you better.',
		description: 'We value your opinion! Help us improve by sharing your experience with us.',
		itemTitle: 'Rate This Item',
		branchTitle: 'Rate Our Restaurant',
		ratingLabel: 'How would you rate your experience?',
		commentLabel: 'Your Feedback',
		optional: '(Optional)',
		itemPlaceholder: 'Tell us what you think about this item...',
		branchPlaceholder: 'Tell us about your overall experience...',
		star: 'star',
		stars: 'stars',
		submit: 'Submit Feedback',
		success: 'Thank you! Your feedback has been submitted successfully.',
		congratulations: 'Congratulations!',
		appreciateYou: 'We appreciate you!',
		error: 'Sorry, there was an error submitting your feedback. Please try again.',
		giveFeedback: 'Give Feedback',
		leaveFeedback: 'Leave Feedback',
		leaveDetailedReview: 'Leave a detailed review',
		leaveFeedbackDescription: 'Share your thoughts and help us improve your experience',
		quickRating: 'Quick Rating',
		quickRatingDescription: 'Rate your overall experience with just a few clicks',
		anonymous: '100% Anonymous',
		anonymousDescription: 'Your feedback is submitted anonymously and securely',
		improving: 'Always Improving',
		improvingDescription: 'We use your feedback to continuously enhance our service',
		valued: 'We value your opinion',
		valuedDescription: 'Every piece of feedback helps us serve you better',
	}
};